import React, { useState, useContext, useEffect } from "react";
import { Card, Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { useAuth } from "../../../../../authentication";
import { CorporateAdminContextApi } from "../../../../../contextApi/CorporateAdminContext";
import "../../../Reports/style.css";

var jwt = require("jsonwebtoken");
const loaderIcon = <LoadingOutlined spin />;

const CRM = () => {
  const { cAdminClientId } = useContext(CorporateAdminContextApi);

  const [iframeUrl, setIframeUrl] = useState("");
  var METABASE_SITE_URL = "https://metabase.dev.perfitrocks.com";
  var METABASE_SECRET_KEY =
    "35731bb474ce2e304a735cb73eb0cb6d529b2a3838f6d6cd6945c71b60e15bfb";
  const { authUser } = useAuth();

  const fetchReportIframe = async (clientId) => {
    var payload = {
      resource: { dashboard: 4 },
      params: {
        clientid: String(clientId),
        corporateadminid: String(authUser.role === "corporateAdmin" ? authUser.id : 0),
      },
      exp: Math.round(Date.now() / 1000) + 10 * 60, // 10 minute expiration
    };

    var token = jwt.sign(payload, METABASE_SECRET_KEY);
    var iframeUrl =
      METABASE_SITE_URL +
      "/embed/dashboard/" +
      token +
      "#bordered=false&titled=false";
    await setIframeUrl(iframeUrl);
  };

  useEffect(() => {
    let dashboardClientId = 0;
    // if corporate admin is logged in and set client for view then need to show perticular client report
    if (cAdminClientId > -1 && authUser.role === "corporateAdmin") {
      dashboardClientId = cAdminClientId;
    } else if (authUser.clientId !== null) {
      dashboardClientId = authUser.clientId;
    }

    setIframeUrl("");
    fetchReportIframe(dashboardClientId);

    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (cAdminClientId > -1 && authUser.role === "corporateAdmin") {
      setIframeUrl("");
      fetchReportIframe(cAdminClientId);
    }

    //eslint-disable-next-line
  }, [cAdminClientId]);

  return (
    <Card
      title={
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            margin: 0,
            padding: 0,
          }}
          className="page-title"
        >
          <span style={{ margin: 0, padding: 0 }}>Dashboard</span>
        </div>
      }
    >
      {iframeUrl !== "" && (
        <div className="iframe-area">
          <iframe
            className="report-iframe"
            src={iframeUrl}
            style={{ width: "100%", minHeight: "720px", border: "0px" }}
            allowtransparency
            allowFullScreen
            title="Report"
          ></iframe>

          <div className="iframe-loader">
            <Spin indicator={loaderIcon} className="SpinnerArea" />
          </div>
        </div>
      )}
    </Card>
  );
};

export default CRM;
